// ----------------------------------------------------------------------
// Stripe Connect Translations - French
// ----------------------------------------------------------------------

export const stripeConnectFr = {
  stripe_connect: {
    // Account selector
    select_account: 'Sélectionner un compte Stripe',
    destination_account: 'Compte de destination',
    no_accounts_available: 'Aucun compte Stripe disponible pour les transferts. Veuillez configurer un compte Stripe dans les paramètres de l\'organisation.',
    personal_account: 'Compte personnel',
    organization_account: 'Compte organisation',
    transfer_destination: 'Destination du transfert',
    transfer_helper_text: 'La part du propriétaire sera transférée sur ce compte après l\'événement',
    select_account_for_transfer: 'Sélectionnez le compte Stripe qui recevra la part du propriétaire',

    // Account status
    status_active: 'Actif',
    status_pending: 'En attente',
    status_inactive: 'Inactif',

    // Alerts and messages
    legal_verification: 'Vérification légale requise',
    complete_stripe_setup: 'Terminer la configuration Stripe',
    complete_setup_short: 'Terminer',
    setup_stripe_account: 'Configurer un compte Stripe',
    setup_short: 'Configurer',
    alert_stripe_incomplete_setup: 'La configuration de votre compte Stripe est incomplète. Veuillez terminer la vérification pour recevoir des paiements.',
    alert_stripe_configuration_title: 'Un compte Stripe Connect est requis pour recevoir les paiements de vos événements.',

    // Multi-account messages
    no_stripe_for_org: 'Aucun compte Stripe pour cette organisation',
    no_stripe_for_org_named: 'Aucun compte Stripe pour "{{orgName}}"',
    using_personal_account_disclaimer: 'Utilisation de votre compte Stripe personnel.',
    configure_org_account: 'Configurer un compte organisation',
    has_stripe_on_other_orgs: 'Vous avez des comptes Stripe sur d\'autres organisations. Configurez cette organisation pour utiliser un compte existant ou créez-en un nouveau dans les paramètres de l\'organisation.',
    has_legacy_account: 'Vous avez un compte Stripe personnel. Activez-le pour cette organisation ou créez-en un nouveau dans les paramètres de l\'organisation.',
    configure_in_settings: 'Configurer dans les paramètres',
    setup_in_org_settings: 'Veuillez configurer les comptes Stripe dans les paramètres de l\'organisation',
    personal_account_available: 'Compte Stripe personnel disponible',
    personal_account_hint: 'Vous avez un compte Stripe personnel qui peut être activé pour "{{orgName}}". Accédez aux paramètres de l\'organisation pour configurer les comptes de paiement.',
    org_setup_incomplete_personal_available: 'Configuration de paiement de l\'organisation incomplète',
    org_setup_incomplete_personal_hint: 'La configuration Stripe pour "{{orgName}}" n\'est pas encore terminée. Votre compte personnel est utilisé en attendant. Terminez la configuration de l\'organisation quand vous le souhaitez.',
    alert_stripe_incomplete_setup_org: 'La configuration du compte Stripe pour "{{orgName}}" est incomplète. Veuillez terminer la vérification pour recevoir des paiements pour vos événements.',
    alert_stripe_configuration_org: 'Pour recevoir des paiements pour les événements de "{{orgName}}", vous devez configurer un compte Stripe Connect. C\'est obligatoire pour la conformité légale et le traitement sécurisé des paiements.',

    // Stripe accounts manager
    stripe_accounts: 'Comptes Stripe',
    stripe_accounts_subtitle: 'Gérer les comptes Stripe Connect pour cette organisation',
    add_account: 'Ajouter un compte',
    add_new_account: 'Ajouter un nouveau compte',
    sync_account: 'Synchroniser le compte',
    set_as_primary: 'Définir comme principal',
    deactivate_account: 'Désactiver le compte',
    edit_account: 'Modifier le compte',
    account_name: 'Nom du compte',
    account_description: 'Description',
    account_name_placeholder: 'ex: Compte principal, Compte festival',
    account_description_placeholder: 'Description optionnelle pour ce compte',
    primary_account: 'Compte principal',
    primary_account_badge: 'Principal',

    // Account stats
    total_accounts: 'Total des comptes',
    active_accounts: 'Comptes actifs',
    pending_accounts: 'Comptes en attente',
    inactive_accounts: 'Comptes inactifs',

    // Account details
    account_id: 'ID du compte',
    charges_enabled: 'Paiements activés',
    payouts_enabled: 'Virements activés',
    details_submitted: 'Détails soumis',
    country: 'Pays',
    currency: 'Devise',
    business_type: 'Type d\'entreprise',
    last_synced: 'Dernière synchronisation',
    created_at: 'Créé le',
    created_by: 'Créé par',

    // Actions
    complete_onboarding: 'Terminer l\'inscription',
    view_dashboard: 'Voir le tableau de bord Stripe',
    refresh_status: 'Actualiser le statut',

    // Confirmations
    confirm_deactivate: 'Êtes-vous sûr de vouloir désactiver ce compte ?',
    confirm_deactivate_description: 'Les comptes désactivés ne peuvent pas recevoir de paiements. Vous pouvez les réactiver ultérieurement.',
    confirm_set_primary: 'Définir ce compte comme principal ?',
    confirm_set_primary_description: 'Le compte principal sera utilisé par défaut pour les nouveaux événements.',

    // Success messages
    account_created: 'Compte Stripe créé avec succès',
    account_updated: 'Compte Stripe mis à jour avec succès',
    account_synced: 'Statut du compte synchronisé avec succès',
    account_deactivated: 'Compte désactivé avec succès',
    primary_account_set: 'Compte principal mis à jour avec succès',

    // Error messages
    error_creating_account: 'Erreur lors de la création du compte Stripe',
    error_updating_account: 'Erreur lors de la mise à jour du compte Stripe',
    error_syncing_account: 'Erreur lors de la synchronisation du statut',
    error_deactivating_account: 'Erreur lors de la désactivation du compte',
    error_setting_primary: 'Erreur lors de la définition du compte principal',
    error_creating_stripe_link: 'Erreur lors de la création du lien d\'inscription Stripe',
    error_creating_stripe_account: 'Erreur lors de la création du compte Stripe',

    // Legacy account
    use_legacy_account: 'Utiliser le compte personnel',
    use_legacy_account_description: 'Utiliser votre compte Stripe personnel lorsqu\'aucun compte organisation n\'est disponible',
    legacy_account_active: 'Votre compte Stripe personnel est actif et peut être utilisé',
    legacy_account_pending: 'Votre compte Stripe personnel nécessite une vérification supplémentaire',
  },

  // Shares distribution (new keys - existing keys like shares_distribution, reservation_details, reservations are in main locale)
  shares_distribution_subheader: 'Aperçu de la répartition des revenus pour cet événement',
  total_sales: 'Ventes totales',

  // Common
  this_organization: 'cette organisation',
};

export default stripeConnectFr;
